import { UserRole } from '../../types';

export default function isAdminUser(role: UserRole): boolean {
  return role === UserRole.ADMIN || role === UserRole.OWNER;
}
